module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机侧题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("升班建议")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search mex-search"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入学生 uid"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "升班建议"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择升班建议"
    },
    model: {
      value: (_vm.queryParam.promotion),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "promotion", $$v)
      },
      expression: "queryParam.promotion"
    }
  }, [_c('Option', {
    attrs: {
      "value": "UP"
    }
  }, [_vm._v("直接升班")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "CONSOLIDATE"
    }
  }, [_vm._v("巩固后升")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "REMEDIATE"
    }
  }, [_vm._v("先补核心")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "REPEAT"
    }
  }, [_vm._v("本级重学")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mex-search-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "list",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/mex/promotions/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36cec49a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mex/MexPromotionList.vue
// module id = 1735
// module chunks = 8